export default "__VITE_ASSET__2AV1GOwA__"